export const userData = (state) => state.userReducers;
